<main class="login-page">
  <div class="image-container">
    <img src="../../../assets/AG_Zest.png" class="image-item" alt="AeroGuest Zest" />
  </div>
  <div class="card" *ngIf="!alreadyLoggedIn">
    <h4 class="card-header" *ngIf="!showForgot">Login</h4>
    <h4 class="card-header" *ngIf="showForgot">Forgot Password</h4>
    <div *ngIf="showLogin" class="card-body">
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <div class="form-group">
          <label for="login-username">Username:</label>
          <input
            id="login-username"
            type="email"
            inputmode="email"
            autocomplete="username"
            autocapitalize="off"
            spellcheck="false"
            formControlName="username"
            class="form-control"
            [ngClass]="{ 'is-invalid': loginSubmitted && fLogin.username.errors }"
            placeholder="name@aeroguest.com"
          />
          <div *ngIf="loginSubmitted && fLogin.username.errors" class="invalid-feedback">
            <div *ngIf="fLogin.username.errors.required">Username is required</div>
          </div>
        </div>

        <div class="form-group">
          <label for="login-password">Password:</label>
          <input
            id="login-password"
            type="password"
            autocomplete="current-password"
            formControlName="password"
            class="form-control"
            [ngClass]="{ 'is-invalid': loginSubmitted && fLogin.password.errors }"
          />
          <div *ngIf="loginSubmitted && fLogin.password.errors" class="invalid-password">
            <div *ngIf="fLogin.password.errors.required">Password is required.</div>
            <div *ngIf="fLogin.password.errors.minlength">Min. length is 8 characters</div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-actions">
            <button type="submit" [disabled]="isWaitingResponse | async" class="btn btn-primary">Login</button>
            <button type="button" (click)="onClickForgotPassword()" class="btn btn-primary btn-forgot">Forgot Password</button>
          </div>
          <div class="error" *ngIf="wrongCredentiels">Wrong Username or Password.</div>
          <div class="error" *ngIf="somethingWentWrong">Something went wrong.</div>
          <div class="error" *ngIf="wrongPin">
            Wrong authentication code. Please try logging in again.
            <br />
            You will receive a new code on your phone.
          </div>
        </div>
      </form>
    </div>

    <div *ngIf="showAuthentication" class="card-body">
      <form (submit)="onAuthenticate()">
        <div class="form-group">
          <label id="auth-code-label">Authentication code:</label>
          <code-input
            [isCodeHidden]="false"
            [isNonDigitsCode]="false"
            [codeLength]="6"
            (codeChanged)="onCodeChanged($event)"
            (codeCompleted)="onCodeCompleted($event)"
            [initialFocusField]="0"
          ></code-input>
          <div class="form-actions">
            <button type="submit" #codeSubmit [disabled]="isWaitingResponse | async" class="btn btn-primary">Enter</button>
          </div>
          <div class="error" *ngIf="wrongPin">Wrong authentication code</div>
        </div>
      </form>
    </div>

    <div *ngIf="showForgot" class="card-body">
      <div *ngIf="!emailSent">
        <form [formGroup]="forgotForm" (ngSubmit)="onForgot()">
          <div class="form-group">
            <label for="forgot-identifier">Enter email:</label>
            <input
              id="forgot-identifier"
              type="email"
              inputmode="email"
              autocomplete="username"
              autocapitalize="off"
              spellcheck="false"
              formControlName="identifier"
              class="form-control"
              [ngClass]="{ 'is-invalid': forgotSubmitted && fForgot.identifier.errors }"
              placeholder="name@aeroguest.com"
            />
            <div *ngIf="forgotSubmitted && fForgot.identifier.errors" class="invalid-feedback">
              <div *ngIf="fForgot.identifier.errors.required">Email is required</div>
            </div>
            <div class="form-actions">
              <button type="submit" [disabled]="isWaitingResponse | async" class="btn btn-primary">Enter</button>
            </div>
            <div class="error" *ngIf="wrongforgot">Email not registered.</div>
          </div>
        </form>
      </div>
      <div *ngIf="emailSent">
        <div class="form-group">
          <label>Email sent to {{ fForgot.identifier.value }}</label>
          <div class="form-actions">
            <button type="button" (click)="toggleLogin()" class="btn btn-primary">Go to login</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" *ngIf="alreadyLoggedIn">
    <h4 class="card-header">Already signed in as: {{ UserLoggedIn }}</h4>
    <div class="card-body">
      <div class="form-actions">
        <button type="button" class="btn btn-primary" (click)="continue()">Continue</button>
        <button type="button" class="btn btn-secondary" (click)="signOut()">Sign out</button>
      </div>
    </div>
  </div>
</main>
